var _dec, _dec2, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(e, i, r, l) {
  r && Object.defineProperty(e, i, {
    enumerable: r.enumerable,
    configurable: r.configurable,
    writable: r.writable,
    value: r.initializer ? r.initializer.call(l) : void 0
  });
}
function _applyDecoratedDescriptor(i, e, r, n, l) {
  var a = {};
  return Object.keys(n).forEach(function (i) {
    a[i] = n[i];
  }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) {
    return n(i, e, r) || r;
  }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function _initializerWarningHelper(r, e) {
  throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
import { bindable, inject, customAttribute } from 'aurelia-framework';
export let SkeletonLoadingAttribute = (_dec = customAttribute('skeleton-loading'), _dec2 = inject(Element), _dec(_class = _dec2(_class = (_class2 = class SkeletonLoadingAttribute {
  constructor(element) {
    _initializerDefineProperty(this, "isLoading", _descriptor, this);
    _initializerDefineProperty(this, "width", _descriptor2, this);
    _initializerDefineProperty(this, "height", _descriptor3, this);
    _initializerDefineProperty(this, "borderRadius", _descriptor4, this);
    _initializerDefineProperty(this, "forceDiv", _descriptor5, this);
    this.isSkeletonDisplayed = false;
    this.skeletonElement = void 0;
    this.element = element;
    this.isLoadingChanged();
  }
  isLoadingChanged() {
    if (this.isLoading) {
      this.turnOnSkeleton();
    } else if (this.isSkeletonDisplayed) {
      this.turnOffSkeleton();
    }
  }
  turnOnSkeleton() {
    if (this.forceDiv || this.element.tagName === 'IMG') {
      this.skeletonElement = document.createElement('div');
      this.skeletonElement.innerHTML = this.element.innerHTML;
      this.copyAttrs(this.skeletonElement, this.element);
    } else {
      this.skeletonElement = this.element.cloneNode(true);
    }
    this.element.parentNode.insertBefore(this.skeletonElement, this.element);
    this.element.classList.add('hidden-skeleton');
    this.skeletonElement.classList.add('skeleton-loading');
    this.skeletonElement.style.setProperty('color', 'transparent', 'important');
    this.skeletonElement.style.setProperty('pointer-events', 'none', 'important');
    this.addDynamicClass('skeletonWidth', this.width);
    this.addDynamicClass('skeletonHeight', this.height);
    if (this.borderRadius) this.skeletonElement.style.borderRadius = this.borderRadius;
    this.isSkeletonDisplayed = true;
  }
  turnOffSkeleton() {
    if (this.element.parentNode.contains(this.skeletonElement)) this.element.parentNode.removeChild(this.skeletonElement);else this.skeletonElement?.remove?.();
    this.element.classList.remove('hidden-skeleton');
    this.isSkeletonDisplayed = false;
  }
  addDynamicClass(varName, value) {
    if (!this.skeletonElement || !value) return;
    this.skeletonElement.style.setProperty(`--${varName}`, `${value}`);
    this.skeletonElement.classList.add(varName);
  }
  copyAttrs(target, source) {
    [...source.attributes].forEach(attr => {
      target.setAttribute(attr.nodeName, attr.nodeValue);
    });
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "isLoading", [bindable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "width", [bindable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "height", [bindable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "borderRadius", [bindable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "forceDiv", [bindable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _class2)) || _class) || _class);